import { useEffect } from 'react';
import AllUserPermissionsGrid from '../../../features/allusers-permissions-grid';
import { ctGameDefault, ctGameTitle } from '../../../constants/text';
import {
  BreadcrumbLocation,
  PrivatePage
} from '../../../components/private-page';

export default function AllUserPermissions() {
  const breadcrumbs: BreadcrumbLocation[] = [
    { label: 'Dashboard', href: '/' },
    { label: 'Administration', href: '../administration' },
    {
      label: 'All user permissions',
      href: '../administration/reports/userpermissions'
    }
  ];

  useEffect(() => {
    document.title = ctGameTitle + ' - All user permissions';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);
  return (
    <PrivatePage
      className={'page-base--full'}
      pageTitle={'Administration'}
      breadcrumb={breadcrumbs}>
      <AllUserPermissionsGrid />
    </PrivatePage>
  );
}
